import script from "./signup-button.vue?vue&type=script&setup=true&lang=js"
export * from "./signup-button.vue?vue&type=script&setup=true&lang=js"

import "./signup-button.vue?vue&type=style&index=0&id=6c9cf38a&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c9cf38a"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
